<div class="content flex flex-col bg-white overflow-hidden">

    <!-- Cabeçalho -->
    <div class="safe-area-top shrink-0">
        <div class="flex items-start justify-between gap-4 mt-4 px-6 pt-1 pb-3">
            <div class="min-w-0">
                <h2 class="text-xl font-semibold text-primary break-words">
                    {{ data.notice.title }}
                </h2>
            </div>

            <mat-icon
                mat-dialog-close
                [svgIcon]="'awesome_solid_6:xmark'"
                class="text-gray-400 cursor-pointer shrink-0">
            </mat-icon>
        </div>
    </div>

    <!-- Conteúdo -->
    <div class="flex flex-col md:flex-row flex-1 min-h-0 overflow-y-auto md:overflow-hidden safe-area-bottom px-4 md:px-8 py-4 gap-4">

        <!-- Imagem e download -->
        <div class="w-full md:w-4/12 shrink-0 flex flex-col">
            <div class="w-full shrink-0">
                <img class="block w-full h-auto max-h-60 md:max-h-none object-contain rounded-lg"
                     [src]="data.notice.coverImageUrl || 'assets/images/notice-board/notice-board-cover.jpg'"
                     [alt]="data.notice.title">

            </div>

            <button *ngIf="data.notice.attachmentKey" type="button"
                    class="inline-flex self-start items-center gap-2 mt-3 min-h-11 max-w-full text-sm text-left text-primary-900 disabled:opacity-50"
                    [disabled]="downloading" (click)="downloadAttachment()">
                <span class="inline-flex shrink-0 items-center gap-1" aria-hidden="true">
                    <mat-icon class="icon-size-5 text-gray-400" [svgIcon]="'awesome_solid:file'"></mat-icon>
                    <span class="rounded-sm bg-red-500 px-1 text-xs font-semibold leading-4 text-white">{{data.notice.attachmentKey.split('.').pop() | uppercase}}</span>
                </span>
                <span class="min-w-0 break-words underline">{{downloading ? 'Baixando arquivo...' : 'Baixar arquivo'}}</span>
            </button>
            <p *ngIf="downloadError" class="mt-2 text-red-600" role="alert">{{downloadError}}</p>
        </div>

        <!-- Mensagem -->
        <div class="w-full md:w-8/12 flex-none md:flex-1 min-w-0 md:min-h-0 md:overflow-y-auto p-2 md:p-4 text-gray-700 break-words">
            <markdown [data]="data.notice.message"></markdown>
        </div>


    </div>

</div>
